/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TodosWidgetContainer_user$ref: FragmentReference;
declare export opaque type TodosWidgetContainer_user$fragmentType: TodosWidgetContainer_user$ref;
export type TodosWidgetContainer_user = {|
  +id: string,
  +$refType: TodosWidgetContainer_user$ref,
|};
export type TodosWidgetContainer_user$data = TodosWidgetContainer_user;
export type TodosWidgetContainer_user$key = {
  +$data?: TodosWidgetContainer_user$data,
  +$fragmentRefs: TodosWidgetContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TodosWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1add81b6529f0c97903c0d0f28d9af8e';
module.exports = node;
